<template>
	<PagePadding class="flex h-[50vh] flex-col items-center justify-center">
		<EmptyInventoryIcon class="h-14 w-14" />
		<div
			class="text-label-primary mt-3 text-center text-sm font-medium uppercase"
		>
			{{ title }}
		</div>
		<div class="text-label-secondary mt-1 text-center text-sm">
			{{ desc }}
		</div>
		<div class="mt-6">
			<slot />
		</div>
	</PagePadding>
</template>
<script setup lang="ts">
import PagePadding from './PagePadding.vue'
import EmptyInventoryIcon from '@/assets/icons/empty-inventory.svg'

defineProps<{
	title: string
	desc: string
}>()
</script>
